import { Suspense, useState } from 'react';
import { P2GIcon, P2GLink, SvgEdit } from '@parcel2go/core-ui';
import React from 'react';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { PublicSettings } from '~/lib/ui-serverless-settings';
const FeedbackForm = React.lazy(() => import('./feedback-form'));

type props = {
  wrapper: (children: React.ReactNode) => JSX.Element;
};

export default function FeedbackButton({ wrapper }: props) {
  const { settings } = useTenant();
  const [open, setOpen] = useState(false);
  const openFeedback = () => setOpen(true);

  if (settings?.[PublicSettings.ORDERPROCESS.SENTRYFEEDBACKENABLED] !== 'true') {
    return null;
  }

  return wrapper(
    <>
      <P2GLink onClick={openFeedback}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <P2GIcon size="xs">
            <SvgEdit />
          </P2GIcon>
          <span>Leave Feedback</span>
        </span>
      </P2GLink>
      {open && (
        <Suspense>
          <FeedbackForm open={open} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
